import React from 'react';
import styled from 'styled-components';
import { toPounds } from './../../services/Formats';
import { AskingQuestions } from './AskingQuestions';

/*
 > button.im {
   min-height: 300px;
   background: url(images/temperature-gray.png) no-repeat 0px 0px;
   background-size: 100%;
 }
 > button.im.active { background-image: url(images/temperature-lightblue.png); }
 > button.im:hover { background-image: url(images/temperature-lightblue.png); }
*/

const LevelsTopDiv = styled.div`
  background: #f5f5f5;
  position: relative;
  margin-bottom: 130px;
  padding: 20px;
  @media(max-width:480px) { margin-bottom: 180px; }
`;

const Columns2 = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 20px;
  border-bottom: 3px #707070 solid;
  .pct { color: #62ad4e; text-align: center; font-weight: bold; font-family: Ubuntu,arial; font-size: 22px;  }
  > .person { width: 60%; }
`;

const LevelsDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: baseline;
  position: relative;

  .title {
     height: 60px;
     width: 100%;
     background: transparent;
     text-align: center;
     color: #707070;
     font-size: 16px;
     font-weight: bold;
     font-family: Ubuntu,arial;
  }
  .amount {
    padding-top: 5px;
    font-size: 16px;
    font-family: Ubuntu, arial;
    font-weight: normal;
    color: #0a2f70;
  }
  @media(max-width:640px) { .title { font-size: 12px; font-weight: normal; } }
  @media(max-width:480px) { .title { font-size: 10px; font-weight: normal; } }
  @media(max-width:640px) { .amount { font-size: 14px; font-weight: normal; } }
  @media(max-width:480px) { .amount { font-size: 12px; font-weight: normal; } }

  .most-common { font-size: 0.66em; font-weight: normal; }
  .person {
    height: 197px;
    img { height: 100%; width: auto; }
    @media(max-width:640px) { height: 150px; }
    @media(max-width:480px) { height: 100px; }
  }

  > button {
    width: 25%;
    border: none;
    cursor: pointer;
    outline: none !important;
    background: transparent;
  }

  .hint {
    display: none;
    position: absolute;
    top: 320px;
    left: 0%;
    width: auto;
    background: #e6f2f3;
    border-radius: 5px;
    font-family: Ubuntu,arial;
    font-size: 16px;
    color: #000;
    padding: 30px 20px;
    margin-left: -20px;
    margin-right: -20px;

    @media(max-width:640px) { top: 275px; }
    @media(max-width:480px) { top: 260px; }

  }
  > button.active .hint { display: block; }
  .coins {
    width: 50px;
    background: url(images/coins-bk.png) 0px 0px no-repeat;
    background-size: 100%;
    position: relative;

    img {
      width: 50px;
      position: absolute;
      left: 0px;
      bottom: 0px;
    }
    @media(max-width:640px) { width: 35px; img { width: 35px; }}
    @media(max-width:680px) { width: 25px; img { width: 25px; }}
  }
  .pct {
    background: #0a2f70;
    color: white;
    border-radius: 50%;
    margin-bottom: 10px;
    height: 64px;
    width: 64px;
    line-height: 64px;
    text-align: center;
    font-size: 16px;

    @media(max-width:640px) { font-size: 14px; height: 50px; width: 50px; line-height: 50px; }
    @media(max-width:480px) { font-size: 10px; height: 40px; width: 40px; line-height: 40px; }
  }
`;

const T = ['Healthy', 'Moderate', 'Mild'];
const FT = ['Lowest LTV', 'Average LTV', 'Highest LTV'];
const I = ['images/level0.png', 'images/level1.png', 'images/level2.png', 'images/level3.png'];
const D = [
  'Would have a Body Mass Index (BMI) within the ‘healthy’ range and would answer ‘No’ to all of our health questions.',
  'Possibly overweight. Could be a smoker. Might also be taking tablets to control an ongoing medical condition such as hypertension (high blood pressure).',
  'Possibly overweight/obese on the BMI scale. May have life-shortening conditions that can have knock-on, long-term effects to health such as diabetes (type 1 or type 2). May have a combination of conditions (e.g. overweight and diabetic).',
  'Possibly obese/morbidly obese on BMI scale. Could have more serious, life-threatening conditions such as cancer, stroke, Parkinson’s etc. Will have ticked ‘Yes’ to a number of questions on our health questionnaire.'
];

const GrayArrowDiv = styled.div`
  position: absolute;
  top: 240px;
  @media(max-width:640px) { top: 210px; }
  @media(max-width:480px) { top: 170px; }

`;

const maxPctValue = 54.5 * 1.3;
const maxCoinsHeight = 130;
export const LevelsOfEnhancement = ({ input, output, onChangePlan, hideLink }) => {
  return (
    <LevelsTopDiv>
      <AskingQuestions  {...{input, output}} hideLink={hideLink} />

      <LevelsDiv key={1}>
        {T.map((t, index) => (
          <button
            key={t} className={`im ${(t === input.ltvPlan) ? 'active' : ''}`}
            onClick={() => (onChangePlan(t))}
          >
            <div>
              <Columns2>
                <div className='person'>
                  <img src={I[index]} alt={input.ltvPlan} />
                </div>
                <div>
                  <div className="pct">{output.ltv.pct[t]}%</div>
                  <div className="coins" style={{ height: output.ltv.pct[t] * maxCoinsHeight / maxPctValue }} >
                  </div>
                </div>
              </Columns2>
            </div>
            <div className={`title ${(t === input.ltvPlan) ? 'active' : ''}`}>
              {FT[index]}
              <br />
              <div className="amount">
                {toPounds(output.ltv[t])}
              </div>
              {(t === 'Highest') ? (
                <div className="most-common">most common enhancement</div>
              ): null}
            </div>

            {/*<div className="hint">*/}
            {/*  <strong>{FT[index]}:</strong> {D[index]}*/}
            {/*</div>*/}
          </button>
        ))}
      </LevelsDiv>
      <div className="disclaimer" style={{ paddingTop: '30px', lineHeight: 1, fontSize: '11px'}}>
        The figures are illustrative only, based on LTVs published as @ 08/02/23. Actual LTVs available at the time of application will depend on the product chosen. They may be higher or lower than the figures displayed above and subject to change. Average LTVs are based on data from Key Group and show the typical amount released at each age.
      </div>


    </LevelsTopDiv>
  );
};



// WEBPACK FOOTER //
// ./src/components/LtvCalculator/LevelsOfEnhancement.js